import { Theme, SxProps } from '@mui/material';

export const sx = {
  container: {
    p: { xs: '12px 18px', sm: '18px 24px' },
    gap: { xs: 6, sm: 12 },
    overflow: 'auto',
  },
  subject: {
    typography: {
      xs: '14_18_600',
      sm: '16_20_600',
    },
  },
  description: {
    typography: {
      xs: '12_22_500',
      sm: '14_24_500',
    },
    pre: {
      fontFamily: (t) => t.typography.fontFamily,
    },
    img: {
      width: '100%',
      maxHeight: 'initial!important',
      maxWidth: '600px!important',
    },
  },
} satisfies Partial<Record<string, SxProps<Theme>>>;
